export default "__VITE_ASSET__BG3HN$gS__"